import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { getLocalStorageRoleNames } from 'src/app/utils/local-storage.util';

@Component({
  selector: 'app-ios-bottom-nav',
  templateUrl: './ios-bottom-nav.component.html',
  styleUrls: ['./ios-bottom-nav.component.scss'],
  standalone: false,
})
export class IosBottomNavComponent {
  hasLearnerRole = false;

  constructor(private router: Router) {
    this.hasLearnerRole = getLocalStorageRoleNames().includes('Learner');
  }

  isActive(route: string, childRoutes: string[] = []): boolean {
    return [route, ...childRoutes].some((url) =>
      this.router.isActive(url, {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })
    );
  }
}
